"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DisplayTypeEnum = exports.DateDisplay = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./DateDisplay.css");

var _styles = {
  "date-display": "DateDisplay__date-display___3AVNn",
  "info": "DateDisplay__info___3Bn3K",
  "warning": "DateDisplay__warning___1nMPu",
  "past-due": "DateDisplay__past-due___1Iw74"
};

const styles = _bind.default.bind(_styles);

var DisplayTypeEnum;
exports.DisplayTypeEnum = DisplayTypeEnum;

(function (DisplayTypeEnum) {
  DisplayTypeEnum["info"] = "info";
  DisplayTypeEnum["warning"] = "warning";
  DisplayTypeEnum["pastDue"] = "past-due";
})(DisplayTypeEnum || (exports.DisplayTypeEnum = DisplayTypeEnum = {}));

const DateDisplay = (0, _mobxReact.observer)(({
  prefixText,
  date,
  displayType = DisplayTypeEnum.info,
  fontSize = 13,
  className,
  dataTestId,
  borderColor = _.Color.neutral._50
}) => {
  const composed_classname = (0, _bind.default)(styles('date-display', displayType, className));
  const formatedDate = typeof date === 'string' ? date : date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
  return _react.default.createElement(_.Flex, {
    className: composed_classname,
    alignItems: 'center',
    style: {
      borderColor
    },
    dataTestId: dataTestId && dataTestId
  }, !prefixText && _react.default.createElement("div", {
    style: {
      paddingRight: '6px'
    }
  }, _react.default.createElement(_.FontAwesome, {
    size: 16,
    name: 'calendar-range',
    color: _.Color.neutral._90
  })), _react.default.createElement(_.Text, {
    dataTestId: dataTestId && `${dataTestId}-date`,
    size: fontSize,
    text: prefixText ? `${prefixText} ${formatedDate}` : formatedDate,
    variant: 'medium'
  }));
});
exports.DateDisplay = DateDisplay;
var _default = DateDisplay;
exports.default = _default;